<template>
  <div id="MyTransfer">
    <div class="filter-dash-btn" @click="handleClick">
      <div class="filter-checked-app" v-if="selectArr.length>0">
        <div
          class="checked-app-item"
          :class="showFullSelectedText ? 'checked-app-item-full' : ''"
        >
          <span :title="showFullSelectedText ? selectedLabelText : selectArr[0].label">
            {{ showFullSelectedText ? selectedLabelText : selectArr[0].label }}
          </span>
        </div>
        <div class="checked-app-item" v-if="selectArr.length>1 && !showFullSelectedText">
          <span>其它{{selectArr.length-1}}项</span>
        </div>
        <i
          @click.stop="handleClear"
          class="el-icon-circle-close checked-clear anticon anticon-close-circle"
        ></i>
      </div>
      <div class="filter-tips-default" v-else>点击选择人员</div>
    </div>
    <el-dialog
      :append-to-body="true"
      title="请选人员"
      :visible.sync="selectDia"
      width="40%"
      :before-close="handleClose"
      @close="handleClosed"
    >
      <div class="container">
        <div class="left">
          <div class="leftHead">
            <i class="el-icon-search"></i>
            <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
          </div>
          <div class="leftBody">
            <el-tree v-if="isLoading" :data="userList" ref="tree" :filter-node-method="filterNode">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-checkbox
                  :class="node.data.colorDefault?'changeChckBoxColor':''"
                  @change="handleCbChange(node)"
                  v-if="node.data.is_department=='0'"
                  :checked="node.data.checked"
                  :label="node.data.id"
                >{{ node.data.show_name }}</el-checkbox>
                <span v-else>{{ node.data.show_name }}</span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="right">
          <div
            class="h3-organization-selected"
            v-for="item in selectArr"
            :key="item.id"
            @click="removeItem(item)"
          >
            <i class="el-icon-user aufontAll h-icon-all-user-o"></i>
            <div class="h3-organization-selected-name">{{item.label}}</div>
            <i class="aufontAll el-icon-close h-icon-all-close"></i>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectDia = false">取 消</el-button>
        <el-button type="primary" @click="getCheckedNodes">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  data() {
    return {
      token: '',
      cache_department_id: '',
      userList: [],
      member_id: '',
      company_id: '',
      details_project_id: '',
      details_project_status: '',
      filterText: '',
      selectArr: [],
      selectDia: false,
      isLoading: true,
      defaultProps: {
        children: 'children',
        label: 'label',
      },
    }
  },
  props: {
    selectedId: {
      type: Array,
      default: () => [],
    },
    isSelected: {
      type: String,
      default: '',
    },
    nextIndex: {
      type: [String, Number],
      default: '',
    },
    showFullSelectedText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedLabelText() {
      return this.selectArr.map((item) => item.label).join('、')
    },
  },
  mounted() {
    // console.log('thisselectedId', this.selectedId)
    // this.isCheckId = this.selectedId
    console.log(this.selectedId)
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    selectedId(val, oldVal) {
      //普通的watch监听
      if (val) {
        this.selectedId = val
      }
      console.log('')
    },
  },
  methods: {
    // ***获取人员列表
    async getUserListWith() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/simple_member',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.userList = res.datas.listInfo
      console.log('选择成员列表', this.userList)
      if (this.isSelected == '1') {
        this.userList.unshift({
          id: '-2',
          is_department: 0,
          colorDefault: true,
          show_name: '部门主管审批',
        })
        this.userList.unshift({
          id: '-1',
          is_department: 0,
          colorDefault: true,
          show_name: '自己审批',
        })
      }
      this.userList.forEach((item) => {
        this.isCheckRecursion(item)
      })
      this.xunhuanList()
    },
    // (递归)循环false
    isCheckRecursion(item) {
      if (!item.children) {
        if (item.is_department != 1) {
          return (item.checked = false)
        } else {
          return
        }
      } else {
        item.children.forEach((items) => this.isCheckRecursion(items))
      }
    },
    xunhuanList() {
      // console.log('this.selectedId', this.selectedId)
      this.userList.forEach((item, index) => {
        this.xunhuanRecursion(item)
      })
    },
    // (递归)xunhuan
    xunhuanRecursion(item) {
      if (!item.children) {
        if (this.selectedId) {
          this.selectedId.forEach((a) => {
            if (item.id == a && item.is_department != 1) {
              this.selectArr.push({
                id: item.id,
                label: item.show_name,
              })
              return (item.checked = true)
            }
          })
          return
        } else {
          return
        }
      } else {
        item.children.forEach((items) => this.xunhuanRecursion(items))
      }
    },
    removeItem(val) {
      this.isLoading = false
      this.userList.forEach((item, index) => {
        if (item.children) {
          item.children.forEach((items) => {
            if (items.children) {
              items.children.forEach((itemss) => {
                if (itemss.id == val.id && itemss.is_department != 1) {
                  return (itemss.checked = false)
                }
              })
            } else {
              if (items.id == val.id && items.is_department != 1) {
                console.log('item.data.', item.data)
                return (items.checked = false)
              }
            }
          })
        } else {
          if (item.id == val.id && item.is_department != 1) {
            item.checked = false
            return console.log('item.data.', item)
          }
        }
      })
      // console.log('this.$refs.tree.data', this.$refs.tree)
      setTimeout(() => {
        this.isLoading = true
      }, 1)

      // let node = this.$refs.tree.getNode(val.id)

      // this.$refs.tree.filter((item) => console.log(item))
      const index = this.selectArr.findIndex((item) => item.id == val.id)
      this.selectArr.splice(index, 1)
      console.log(this.userList)
      // console.log(this.$refs.tree)
      // this.$emit('my-transfer-change', this.selectArr)
      if (this.nextIndex) {
        this.$emit('my-transfer-change', this.selectArr, this.nextIndex)
      } else {
        this.$emit('my-transfer-change', this.selectArr)
      }
    },
    // (递归)remove
    removeRecursion(item) {
      if (!item.children) {
        if (item.id == val.id && item.is_department != 1) {
          return (item.checked = false)
          //  return console.log('item.data.', item)
        } else {
          return
        }
      } else {
        item.children.forEach((items) => this.removeRecursion(items))
      }
    },
    handleCbChange(node) {
      // this.isLoading = false
      // node.checked = node.data.checked
      node.data.checked = !node.data.checked
      console.log('node', node)
      const index = this.selectArr.findIndex((item) => item.id == node.data.id)
      if (index == -1) {
        this.selectArr.push({
          id: node.data.id,
          label: node.data.show_name,
        })
      } else {
        this.selectArr.splice(index, 1)
      }
      // setTimeout(() => {
      //   this.isLoading = true
      // }, 1)
      console.log('this.userList', this.userList)
      console.log('选中的', this.selectArr)
      console.log('this.nextIndex1', this.nextIndex)
      if (this.nextIndex) {
        this.$emit('my-transfer-change', this.selectArr, this.nextIndex)
      } else {
        this.$emit('my-transfer-change', this.selectArr)
      }
    },
    filterNode(value, data) {
      console.log('value', value)
      if (!value) return true
      return data.show_name.indexOf(value) !== -1
    },
    showRadio(node) {
      console.log(node)
      return node.childNodes.length === 0 ? true : false
    },
    handleClear() {
      this.isLoading = false
      // this.$refs.tree.data.forEach((item) => {
      //   if (item.children) {
      //     item.children.forEach((items) => {
      //       if (items.children) {
      //         items.children.forEach((itemss) => {
      //           if (itemss.checked) {
      //             return (itemss.checked = false)
      //           }
      //         })
      //       } else {
      //         if (items.checked) {
      //           return (items.checked = false)
      //         }
      //       }
      //     })
      //   } else {
      //     if (item.checked) {
      //       return (item.checked = false)
      //     }
      //   }
      // })
      this.userList.forEach((item, index) => {
        if (item.children) {
          item.children.forEach((items) => {
            if (items.children) {
              items.children.forEach((itemss) => {
                itemss.checked = false
              })
            } else {
              items.checked = false
            }
          })
        } else {
          item.checked = false
        }
      })
      this.selectArr = []
      setTimeout(() => {
        this.isLoading = true
      }, 1)
      // this.$emit('my-transfer-change', this.selectArr)
      if (this.nextIndex) {
        this.$emit('my-transfer-change', this.selectArr, this.nextIndex)
      } else {
        this.$emit('my-transfer-change', this.selectArr)
      }
    },
    // (递归)clear
    clearRecursion(item) {
      if (!item.children) {
        return (item.checked = false)
      } else {
        item.children.forEach((items) => this.clearRecursion(items))
      }
    },
    getCheckedNodes() {
      // this.$emit('my-transfer-change', this.selectArr)
      if (this.nextIndex) {
        this.$emit('my-transfer-change', this.selectArr, this.nextIndex)
      } else {
        this.$emit('my-transfer-change', this.selectArr)
      }
      console.log(
        'this.selectArrthis.selectArrthis.selectArrthis.selectArrthis.selectArr',
        this.selectArr
      )
      this.selectDia = false
    },
    handleClick() {
      this.selectDia = true
    },
    handleClose() {
      this.selectDia = false
    },
    handleClosed() {
      this.filterText = ''
    },
  },
  created: function () {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    setTimeout(() => {
      this.getUserListWith()
    })
  },
}
</script>
<style lang="less" scoped>
#MyTransfer {
  display: flex;
  align-items: center;
}
#MyTransfer {
  font-size: 14px;
}

#MyTransfer .filter-item-name {
  margin-right: 15px;
  text-align: right;
}
#MyTransfer .filter-item-wrapper {
  display: flex;
  align-items: center;
}
#MyTransfer .filter-dash-btn {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 234px;
  width: 100%;
  height: 40px;
  // border-radius: 4px;
  border: 1px solid #c9ccd8;
  color: #c9ccd8;
  cursor: pointer;
  transition: all 0.3s;
}
#MyTransfer .filter-item-wrapper .filter-dash-btn:hover {
  border: 1px dashed #107fff;
}
#MyTransfer .filter-tips-default {
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
  padding-left: 15px;
  align-items: center;
  width: 100%;
  height: 32px;
  transition: all 0.3s;
}
#MyTransfer .filter-item-wrapper .filter-dash-btn:hover .filter-tips-default {
  color: #107fff;
}
.filter-checked-app {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  padding: 4px;
}
.checked-app-item {
  padding: 2px 6px;
  margin: 0 4px 0 0;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
}
.checked-app-item-full {
  flex: 1;
  min-width: 0;
  margin-right: 20px;
}
.checked-app-item-full span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.checked-clear {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #ccc;
  transition: color 0.2s;
}
.checked-clear:hover {
  color: #aaa;
}

// 修改弹窗样式
// dialog弹窗
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
}
/deep/ .el-dialog__header {
  padding: 16px 24px;
  color: #304265;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
  .el-dialog__title {
    margin: 0;
    color: #304265;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
}
/deep/.el-dialog__body {
  padding: 0;
  font-size: 14px;
  line-height: 1.5;
  .container {
    width: 100%;
    display: flex;
    .left {
      width: 55%;
      border-right: 1px solid #e8e8e8;
      box-sizing: border-box;
      .leftHead {
        display: flex;
        align-items: center;
        padding: 12px 24px;
        border-bottom: 1px solid #e8e8e8;
        i {
          color: #aaa;
        }
        // (deep)
        .el-input__inner {
          height: 22px;
          border: none;
          padding-left: 10px;
        }
      }
      .leftBody {
        box-sizing: border-box;
        padding-left: 10px;
        padding-top: 10px;
        height: 344px;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
    .right {
      box-sizing: border-box;
      padding: 16px;
      width: 45%;
      height: 390px;
      overflow-x: hidden;
      overflow-y: scroll;
      .h3-organization-selected {
        position: relative;
        display: inline-block;
        background: #fafafa;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        padding: 0 24px 0 26px;
        margin: 0 8px 8px 0;
        height: 22px;
        max-width: 100%;
        .el-icon-user {
          left: 8px;
          margin-right: 6px;
          font-size: 12px;
          color: #bfbfbf;
          transform: translateY(-50%);
          position: absolute;
          top: 50%;
        }
        .el-icon-close {
          color: #bfbfbf;
          transform: translateY(-50%);
          position: absolute;
          top: 50%;
          width: 10px;
          height: 10px;
          font-size: 10px;
          margin-left: 8px;
          right: 8px;
        }
        .h3-organization-selected-name {
          display: inline-block;
          height: 100%;
          line-height: 1.5;
          max-width: 215px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
/deep/ .el-dialog__footer {
  padding: 10px 16px;
  text-align: right;
  border-top: 1px solid #e8e8e8;
  .el-button {
    height: 32px;
    padding: 0 15px;
  }
}
// 修改弹窗样式
.changeChckBoxColor {
  /deep/.el-checkbox__label {
    color: #567ab3;
    // color: red;
  }
}
</style>
